import useDisplayNames from '../useDisplayNames'
import pluralize from 'pluralize'

const useValuePropositiveDisplayName = () => {
    const { getDisplayName } = useDisplayNames()

    const singular = getDisplayName('valueProposition', 'Value Proposition')
    const plural = pluralize(singular)

    return { singular, plural }
}

export default useValuePropositiveDisplayName
